export const ROUTE_COLOR = ['#00954e', '#dd3497', '#225ea8'];
